import React from "react";

interface PlatformItem {
  icon: string;
  title: string;
  text: string;
  bullets: string[];
}

interface PlatformProps {
  data?: {
    title: string;
    subtitle: string;
    items: PlatformItem[];
  };
}

export const Platform: React.FC<PlatformProps> = ({ data }) => (
  <section id="plataforma" className="relative py-24">
    <div className="absolute inset-0 -z-10 bg-gradient-to-br from-blue-50 via-white to-cyan-50" />
    <div className="mx-auto max-w-6xl px-6 lg:px-8">
      <div className="text-center mb-12">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-red-600">
          Plataforma Sengia
        </p>
        <h2 className="mt-3 text-3xl font-semibold text-slate-900 sm:text-4xl">
          {data?.title ?? "Plataforma completa"}
        </h2>
        <p className="mt-4 max-w-2xl mx-auto text-slate-600">
          {data?.subtitle ?? "Loading..."}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {data?.items?.length ? (
          data.items.map((item, index) => (
            <div
              key={index}
              className="flex flex-col rounded-2xl border border-slate-200/70 bg-white/90 p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-soft animate-fade-up"
              style={{ animationDelay: `${index * 70}ms` }}
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-100 text-blue-700">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="text-lg font-semibold text-slate-900">
                  {item.title}
                </h3>
              </div>
              <p className="text-sm leading-relaxed text-slate-600 mb-4">
                {item.text}
              </p>
              <ul className="space-y-2 text-sm text-slate-600">
                {item.bullets.map((bullet, bulletIndex) => (
                  <li key={bulletIndex} className="flex items-start gap-2">
                    <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-cyan-500" />
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))
        ) : (
          <p className="text-slate-600">Loading...</p>
        )}
      </div>
    </div>
  </section>
);
